import React from 'react';
import video from '../../assets/videos/Herosection1080.mp4';

const HeroSection = () => {
  return (
    <section className="relative w-full h-screen">
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
        preload="auto"
      >
        <source src={video} type="video/mp4" />
      </video>
    </section>
  );
};

export default HeroSection;
